import React from 'react';
import clsx from 'clsx';
import type { NotificationMode } from '../lib/types';

export type NotificationModeOption = NotificationMode | 'default';

export function NotificationModeSelector(props: {
  value: NotificationModeOption;
  onChange: (next: NotificationModeOption) => void;
  options?: NotificationModeOption[];
  labels?: Partial<Record<NotificationModeOption, string>>;
  size?: 'sm' | 'md';
}) {
  const options = props.options ?? ['off', 'immediate', 'summary'];
  const size = props.size ?? 'md';

  return (
    <div className="inline-flex rounded-xl border border-zinc-300 bg-white p-1">
      {options.map((option) => {
        const active = props.value === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => props.onChange(option)}
            className={clsx(
              'rounded-lg font-medium transition',
              size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
              active ? 'bg-accent text-white' : 'text-zinc-700 hover:bg-zinc-100'
            )}
          >
            {props.labels?.[option] ?? labelForOption(option)}
          </button>
        );
      })}
    </div>
  );
}

export function labelForOption(option: NotificationModeOption) {
  if (option === 'default') return 'Default';
  if (option === 'off') return 'Off';
  if (option === 'immediate') return 'Immediate';
  return 'Summary';
}
